// Traduções para diferentes idiomas
export const translations = {
    portugues: {
        // Mensagens de boas-vindas
        welcomeMessage: 'Bem vindo ao evento',

        // Botões
        startRegistration: 'Iniciar Cadastro',
        acceptInvite: 'Aceitar Convite',
        declineInvite: 'Recusar Convite',
        acceptTerms: 'Aceitar Termos',
        declineTerms: 'Recusar Termos',
        save: 'Salvar',
        next: 'Próximo',
        back: 'Voltar',
        confirm: 'Confirmar',
        cancel: 'Cancelar',

        // Mensagens de erro
        error: 'Erro: ',
        errorLoadingDefault: ' ao carregar dados',
        errorRefreshPage: ' tente atualizar a página',
        errorSaving: 'Erro: ',
        errorSavingDefault: ' ao salvar dados',

        // Mensagens de status
        loading: 'Carregando...',
        deadlineExpired: 'Prazo de confirmação encerrado.',
        linkDisabled: 'Este link está temporariamente desativado.',

        // Mensagens de formulário
        edit: 'Editar',
        delete: 'Excluir',
        previous: 'Anterior',

        // Mensagens de validação
        requiredField: 'Campo obrigatório',
        invalidEmail: 'E-mail inválido',
        invalidFormat: 'Formato inválido',
        requiredVinculoOrgaoPublico: 'É necessário preencher se tem vínculo com órgão público',
        requiredNome: 'É necessário preencher o nome',
        requiredContato: 'É necessário preencher o Nome para Crachá',
        requiredCelular: 'É necessário preencher o celular',
        requiredTelefone: 'É necessário preencher o telefone',
        requiredEmail: 'É necessário preencher o e-mail',
        requiredRg: 'É necessário preencher o RG',
        requiredCpf: 'É necessário preencher o CPF',
        requiredCrm: 'É necessário preencher o CRM',
        requiredCrmUf: 'É necessário preencher o Estado do CRM',
        requiredDataNascimento: 'É necessário preencher a Data de Nascimento',
        requiredEspecialidade: 'É necessário preencher a Especialidade',
        requiredInstituicao: 'É necessário preencher a instituição',
        requiredCep: 'É necessário preencher o CEP',
        requiredRua: 'É necessário preencher a rua',
        requiredNumero: 'É necessário preencher o número',
        requiredBairro: 'É necessário preencher o bairro',
        requiredMunicipio: 'É necessário preencher o Município',
        requiredCidadeEmbarque: 'É necessário preencher a Cidade de Embarque',
        requiredEstado: 'É necessário preencher o Estado',
        requiredRestricaoAlimentar: 'É necessário preencher Restrição Alimentar',
        requiredPcd: 'É necessário preencher PCD',
        requiredColumn: 'É necessário preencher',

        // Mensagens de sucesso
        savedSuccessfully: 'Salvo com sucesso!',
        updatedSuccessfully: 'Atualizado com sucesso!',
        deletedSuccessfully: 'Excluído com sucesso!',

        // Mensagens de confirmação
        confirmDelete: 'Tem certeza que deseja excluir?',
        confirmAction: 'Tem certeza que deseja realizar esta ação?',

        // Títulos das telas
        cartaInformativa: 'Carta Informativa',
        aceitarConvite: 'Aceitar Convite',
        aceitarTermo: 'Aceitar Termos',
        cadastroDados: 'Cadastro de Dados',
        confirmacao_dados_titulo: 'Confirmação de dados',
        escolhaAereo: 'Escolha de Aéreo',
        escolhaTransfer: 'Escolha de Transfer',
        escolhaHotel: 'Escolha de Hotel',

        // Mensagens específicas das telas
        agreeWithTerms: 'Eu concordo com os termos acima',
        presenceConfirmed: 'Sua presença está confirmada para o evento',
        moreDetailsSoon: 'em breve enviaremos mais detalhes sobre sua participação.',
        contactInfo: 'Caso haja qualquer alteração nas informações ou dúvidas para o andamento do processo, estamos a disposição nos contatos abaixo:',
        accessGroup: 'Grupo Access-Mkt - Horário de atendimento de Segunda a Sexta das 09:00 às 18:00',
        phone: 'Telefone: (11) 3777-8414',
        clickBelowAccess: 'clique abaixo e acesse o material de apoio',
        accessContent: 'Acessar Conteúdo',
        refusalRegistered: 'A sua recusa na participação do evento',
        wasRegistered: 'foi registrada.',
        thankYou: 'Obrigado!',

        // Mensagens de termos LGPD
        termoLgpd: 'Termo de LGPD',
        lgpdInfo1: 'Todas as informações fornecidas durante o processo de RSVP serão usadas exclusivamente para a realização dos serviços associados a este evento. Esses dados serão gerenciados pela equipe da Access-Mkt e compartilhados com a agência de eventos contratante e/ou a empresa que organiza o evento. Eles, por sua vez, podem compartilhar essas informações com fornecedores como hotéis, agências de transporte, companhias aéreas, organizadores de congressos e feiras, empresas de seguro de viagem, entre outros, conforme necessário para oferecer os serviços relacionados ao seu patrocínio.',
        lgpdInfo2: 'A Access-Mkt assume a responsabilidade de adotar medidas de segurança, incluindo medidas técnicas e administrativas, para proteger os dados pessoais contra acessos não autorizados. Para isso, utilizamos um sistema próprio com um desenvolvedor responsável, um banco de dados MySQL altamente seguro, comunicações de dados criptografadas e servidores locais protegidos por firewall e criptografia de arquivos.',
        lgpdInfo3: 'Se você desejar, a qualquer momento, terá o direito de acessar os dados coletados pela Access-Mkt. Além disso, pode solicitar a correção, bloqueio ou exclusão desses dados, assim como revogar o consentimento fornecido.',
        lgpdInfo4: 'Ao clicar no botão "Aceitar o convite", você está ciente de que está compartilhando dados pessoais, incluindo informações confidenciais ou sensíveis conforme definido pela Lei Geral de Proteção de Dados (LGPD), com o banco de dados de registro e participação da Access-Mkt.',
        lgpdInfo5: 'Por outro lado, se você optar por "Declinar o convite" e selecionar a opção de não concordar com os termos da LGPD, seu registro não será submetido ou processado, o que inviabilizará a continuidade dos serviços necessários para sua participação.',
        lgpdInfo6: 'Os dados pessoais coletados para este evento serão tratados em estrita conformidade com a Lei Federal nº 13.709/2018 (Lei Geral de Proteção de Dados).',
        downloadTerms: 'Você pode baixar os termos acima clicando no link:',
        downloadLgpdTerms: 'Baixar Termos LGPD',
        naoAceitoOsTermos: 'Não aceito os termos',
        aceitoOsTermos: 'Aceito os termos',
        temCerteza: 'Tem certeza?',
        lgpdWarning: 'Para dar andamento aos processos de aceite do convite, é imprescindível o aceite nas normas e regras da LGPD, devido a lei de proteção de dados.',
        voltar: 'Voltar',
        naoAceitoOsTermosConfirm: 'Não aceito os termos',

        // Mensagens de aéreo
        noAereoOptions: 'Não há opções de aéreo disponíveis.',
        aereoOptions: 'Opções de Aéreo',
        selectAereo: 'Selecione uma opção de aéreo',
        ida: 'Ida',
        volta: 'Volta',
        retorno: 'Retorno',
        data: 'Data',
        cia: 'Cia',
        voo: 'Voo',
        origem: 'Origem',
        destino: 'Destino',
        saida: 'Saida',
        chegada: 'Chegada',
        aereoNaoAtende: 'Aéreo não me atende',
        motivoAereoIda: 'Por favor, informe o motivo...',
        motivoAereoVolta: 'Por favor, informe o motivo...',
        necessitaBagagem: 'Necessita de despacho de bagagem?',
        nao: 'Não',
        sim: 'Sim',
        informacoesImportantesAereo: 'Informações Importantes de Aéreo',
        opcaoAereoEmissao: 'A opção de aéreo escolhida será enviada para emissão e só será emitida conforme disponibilidade. Entraremos em contato caso seja necessário validar algum ajuste.',
        documentacaoObrigatoria: 'Documentação obrigatória para essa viagem:',
        documentoNacional: 'R.G. com emissão inferior a 10 anos ou CNH válida',
        documentoInternacional: 'Passaporte com validade mínima de 6 meses. Vistos consulares dentro validade quando necessário',
        enviarCopiaDocumento: 'Favor enviar copia do passaporte/RG e visto (se necessário) para o e-mail:',
        responsabilidadePatrocinio: 'se responsabiliza exclusivamente pelo patrocínio das passagens aéreas necessárias ao seu comparecimento no evento e período descrito no convite.',
        alteracoesResponsabilidade: 'Alterações serão de responsabilidade do convidado.',
        confirmarNomeDocumento: 'Favor nos confirmar se seu nome está descrito da mesma maneira que em seu documento original apresentado para embarque.',
        informacaoImportante: 'Essa informação é muito importante para evitarmos transtornos no momento de seu embarque.',
        observacoesImportantes: 'Observações Importantes:',
        alteracaoAposEmissao: '- Informamos que qualquer tipo de alteração após a emissão do bilhete, será de total responsabilidade do participante.',
        despesasAcompanhanteResponsabilidade: '- Em virtude de o evento ser patrocinado pela Sanofi e ter caráter de educação/informação científica, informamos que as despesas ocorridas por conta do(s) acompanhante(s) serão de responsabilidade de V.Sa.',
        assinaturaSanofi: 'Sanofi',
        opcaoVooNaoAtende: 'As opções de voo apresentadas não atendem às minhas necessidades, preciso de um contato pelo seguinte motivo:',
        motivo: 'Motivo...',
        atencao: 'Atenção',
        analisarSolicitacao: 'Analisaremos a sua solicitação e entraremos em contato em breve.',
        confirmarAeroporto: 'Você confirma o aeroporto de embarque:',
        opcaoVooEscolhida: 'e a opção de voo escolhida?',
        confirmar: 'Confirmar',
        cancelar: 'Cancelar',
        escolherOpcaoIda: 'É necessário escolher uma opção de IDA ou informar que o aéreo não atende',
        escolherOpcaoVolta: 'É necessário escolher uma opção de VOLTA ou informar que o aéreo não atende',
        informarMotivoIda: 'É necessário informar o motivo pelo qual o aéreo de IDA não atende suas necessidades',
        informarMotivoVolta: 'É necessário informar o motivo pelo qual o aéreo de VOLTA não atende suas necessidades',
        preencherBagagem: 'É necessário preencher se necessita de despacho de bagagem',
        salvar: 'Salvar',

        // Mensagens de transfer
        noTransferOptions: 'Não há opções de transfer disponíveis.',
        transferOptions: 'Opções de Transfer',
        selectTransfer: 'Selecione uma opção de transfer',
        transfer: 'Transfer',
        transferExtra: 'Transfer extra:',
        transferExtraDescricao: 'Transfer residência x aeroporto e/ou evento x residência',
        dataHorarioTransfer: 'Data e horário do transfer serão agendados conforme agenda do evento e informados na carta informativa.',
        informarEndereco: 'Por favor informe seu endereço:',
        enderecoPlaceholder: 'Endereço...',
        transferDescricao: 'Transfer:',
        transferDescricaoCompleta: 'Aeroporto x Hotel x Aeroporto',
        naoUtilizarTransfer: 'Se você não for utilizar, ou tiver alguma dúvida sobre o serviço de transfer, por favor nos informe no campo abaixo:',
        informacoesImportantesTransfer: 'Informações Importantes de Transfer',
        servicoExclusivo: 'Ressaltamos que este serviço é exclusivo para o(a)',
        medico: 'médico(a)',
        convidado: 'convidado(a)',
        patrocinado: 'patrocinado(a), não estendido ao acompanhante. Este serviço será oferecido nos horários correspondentes a sua reserva aérea, desde que corresponda ao período do evento do qual temos relacionado em nosso banco de dados.',
        alterarVoo: 'Caso decida alterar o seu voo, o transfer será cancelado e o deslocamento ficará sob responsabilidade do(a)',
        alteracoesAtrasos: 'Em caso de alteração, atrasos e/ou cancelamentos de voos por parte da Cia. aérea, solicitamos a gentileza de entrar em contato conosco através do telefone (11)3777-8414, para que possamos providenciar os ajustes no transfer programado.',

        // Mensagens de hotel
        noHotelOptions: 'Não há opções de hotel disponíveis.',
        hotelOptions: 'Opções de Hotel',
        selectHotel: 'Selecione uma opção de hotel',
        hospedagem: 'Hospedagem',
        endereco: 'Endereço:',
        checkin: 'Check-in:',
        checkout: 'Check-out:',
        tipoApartamento: 'Tipo do apartamento:',
        emBreveMaisInformacoes: 'Em breve enviaremos mais informações',
        patrocinioDisponivel: 'Patrocínio disponível durante o período do evento.',
        naoUtilizarHospedagem: 'Se você não for utilizar, ou tiver alguma dúvida sobre o serviço de hospedagem, por favor nos informe no campo abaixo:',
        observacaoPlaceholder: '...',

        // Mensagens de contrato
        contractSent: 'Contrato enviado com sucesso!',

        // Campos do formulário
        nome_completo_documento: 'Nome Completo (conforme o seu documento)',
        nome_completo_documento_label: 'Nome Completo (conforme o seu documento)',
        nome_atencao_aereo: '* caso tenha Aéreo favor se atentar, o nome deve ser igual documento de embarque',
        nome_cracha: 'Nome para o Crachá',
        nome_cracha_label: 'Nome para o Crachá',
        celular: 'Celular',
        celular_label: 'Celular',
        telefone: 'Telefone',
        telefone_label: 'Telefone',
        email: 'E-mail',
        email_label: 'E-mail',
        rg: 'RG',
        rg_label: 'RG',
        cpf: 'CPF',
        cpf_label: 'CPF',
        crm: 'CRM',
        crm_label: 'CRM',
        estado_crm_label: 'Estado do CRM',
        data_nascimento_label: 'Data de Nascimento',
        especialidade: 'Especialidade',
        especialidade_label: 'Especialidade',
        instituicao: 'Instituição',
        instituicao_label: 'Instituição',
        cep: 'CEP',
        cep_label: 'CEP',
        rua_logradouro: 'Rua / Logradouro',
        rua_logradouro_label: 'Rua / Logradouro',
        numero: 'Número',
        numero_label: 'Número',
        complemento: 'Complemento',
        complemento_label: 'Complemento',
        bairro: 'Bairro',
        bairro_label: 'Bairro',
        cidade_label: 'Cidade',
        estado_label: 'Estado',
        cidade_embarque_label: 'Cidade de Embarque',
        necessidade_especial_descricao: 'Caso tenha alguma necessidade especial, favor sinalizar abaixo:',
        restricao_alimentar_label: 'Restrição Alimentar',
        especifique_restricao_alimentar: 'Especifique a restrição alimentar',
        pcd_label: 'PCD',
        especifique_necessidade_especial: 'Especifique a necessidade especial',
        confirmar_dados_botao: 'Confirmar dados',

        // Vínculo com órgão público
        noVinculoOrgaoPublico: 'Não possui qualquer espécie de vínculo com Órgão Público',
        vinculoOrgaoPublico: 'Possuí vínculo com Órgão Público, mesmo que de forma indireta. (Especifique o vínculo)',
        otherVinculoOrgaoPublico: 'Outros. Especifique:',
        specifyVinculoOrgaoPublico: 'Por favor, especifique o vínculo com o órgão público...',
        enterCpf: 'Digite seu CPF'
    },
    ingles: {
        // Welcome messages
        welcomeMessage: 'Welcome to the event',

        // Buttons
        startRegistration: 'Start Registration',
        acceptInvite: 'Accept Invite',
        declineInvite: 'Decline Invite',
        acceptTerms: 'Accept Terms',
        declineTerms: 'Decline Terms',
        save: 'Save',
        next: 'Next',
        back: 'Back',
        confirm: 'Confirm',
        cancel: 'Cancel',

        // Error messages
        error: 'Error: ',
        errorLoadingDefault: ' loading data',
        errorSaving: 'Error: ',
        errorSavingDefault: ' saving data',

        // Status messages
        loading: 'Loading...',
        deadlineExpired: 'Confirmation deadline has expired.',
        linkDisabled: 'This link is temporarily disabled.',

        // Form messages
        edit: 'Edit',
        delete: 'Delete',
        previous: 'Previous',

        // Validation messages
        requiredField: 'Required field',
        invalidEmail: 'Invalid email',
        invalidFormat: 'Invalid format',
        requiredVinculoOrgaoPublico: 'It is necessary to fill in if you have a connection with a public agency',
        requiredNome: 'It is necessary to fill in the name',
        requiredContato: 'It is necessary to fill in the Name for Badge',
        requiredCelular: 'It is necessary to fill in the mobile',
        requiredTelefone: 'It is necessary to fill in the phone',
        requiredEmail: 'It is necessary to fill in the email',
        requiredRg: 'It is necessary to fill in the ID',
        requiredCpf: 'It is necessary to fill in the CPF',
        requiredCrm: 'It is necessary to fill in the CRM',
        requiredCrmUf: 'It is necessary to fill in the CRM State',
        requiredDataNascimento: 'It is necessary to fill in the Date of Birth',
        requiredEspecialidade: 'It is necessary to fill in the Specialty',
        requiredInstituicao: 'It is necessary to fill in the institution',
        requiredCep: 'It is necessary to fill in the ZIP Code',
        requiredRua: 'It is necessary to fill in the street',
        requiredNumero: 'It is necessary to fill in the number',
        requiredBairro: 'It is necessary to fill in the neighborhood',
        requiredMunicipio: 'It is necessary to fill in the Municipality',
        requiredCidadeEmbarque: 'It is necessary to fill in the Departure City',
        requiredEstado: 'It is necessary to fill in the State',
        requiredRestricaoAlimentar: 'It is necessary to fill in Dietary Restriction',
        requiredPcd: 'It is necessary to fill in PWD',
        requiredColumn: 'It is necessary to fill in',

        // Success messages
        savedSuccessfully: 'Saved successfully!',
        updatedSuccessfully: 'Updated successfully!',
        deletedSuccessfully: 'Deleted successfully!',

        // Confirmation messages
        confirmDelete: 'Are you sure you want to delete?',
        confirmAction: 'Are you sure you want to perform this action?',

        // Screen titles
        cartaInformativa: 'Informative Letter',
        aceitarConvite: 'Accept Invitation',
        aceitarTermo: 'Accept Terms',
        cadastroDados: 'Data Registration',
        confirmacao_dados_titulo: 'Data Confirmation',
        escolhaAereo: 'Air Travel Selection',
        escolhaTransfer: 'Transfer Selection',
        escolhaHotel: 'Hotel Selection',

        // Screen specific messages
        agreeWithTerms: 'I agree with the terms above',
        presenceConfirmed: 'Your presence is confirmed for the event',
        moreDetailsSoon: 'we will send more details about your participation soon.',
        contactInfo: 'If there are any changes in the information or questions about the process, we are available at the contacts below:',
        accessGroup: 'Access-Mkt Group - Service hours Monday to Friday from 09:00 to 18:00',
        phone: 'Phone: (11) 3777-8414',
        clickBelowAccess: 'click below and access the support material',
        accessContent: 'Access Content',
        refusalRegistered: 'Your refusal to participate in the event',
        wasRegistered: 'has been registered.',
        thankYou: 'Thank you!',

        // LGPD Terms messages
        termoLgpd: 'LGPD Terms',
        lgpdInfo1: 'All information provided during the RSVP process will be used exclusively for the provision of services associated with this event. This data will be managed by the Access-Mkt team and shared with the contracting event agency and/or the company organizing the event. They, in turn, may share this information with suppliers such as hotels, transportation agencies, airlines, congress and fair organizers, travel insurance companies, among others, as necessary to provide services related to your sponsorship.',
        lgpdInfo2: 'Access-Mkt assumes responsibility for adopting security measures, including technical and administrative measures, to protect personal data against unauthorized access. For this, we use our own system with a responsible developer, a highly secure MySQL database, encrypted data communications and local servers protected by firewall and file encryption.',
        lgpdInfo3: 'If you wish, at any time, you will have the right to access the data collected by Access-Mkt. In addition, you can request the correction, blocking or deletion of this data, as well as revoke the consent provided.',
        lgpdInfo4: 'By clicking the "Accept invitation" button, you are aware that you are sharing personal data, including confidential or sensitive information as defined by the General Data Protection Law (LGPD), with the Access-Mkt registration and participation database.',
        lgpdInfo5: 'On the other hand, if you choose to "Decline invitation" and select the option not to agree with the LGPD terms, your registration will not be submitted or processed, which will prevent the continuity of services necessary for your participation.',
        lgpdInfo6: 'Personal data collected for this event will be processed in strict compliance with Federal Law No. 13.709/2018 (General Data Protection Law).',
        downloadTerms: 'You can download the terms above by clicking the link:',
        downloadLgpdTerms: 'Download LGPD Terms',
        naoAceitoOsTermos: 'I do not accept the terms',
        aceitoOsTermos: 'I accept the terms',
        temCerteza: 'Are you sure?',
        lgpdWarning: 'To proceed with the invitation acceptance processes, it is essential to accept the LGPD rules and regulations, due to data protection law.',
        voltar: 'Back',
        naoAceitoOsTermosConfirm: 'I do not accept the terms',

        // Air travel messages
        noAereoOptions: 'No air travel options available.',
        aereoOptions: 'Air Travel Options',
        selectAereo: 'Select an air travel option',
        ida: 'Departure',
        volta: 'Return',
        retorno: 'Return',
        data: 'Date',
        cia: 'Airline',
        voo: 'Flight',
        origem: 'Origin',
        destino: 'Destination',
        saida: 'Departure',
        chegada: 'Arrival',
        aereoNaoAtende: 'Air travel does not meet my needs',
        motivoAereoIda: 'Please inform the reason...',
        motivoAereoVolta: 'Please inform the reason...',
        necessitaBagagem: 'Do you need checked baggage?',
        nao: 'No',
        sim: 'Yes',
        informacoesImportantesAereo: 'Important Air Travel Information',
        opcaoAereoEmissao: 'The chosen air travel option will be sent for issuance and will only be issued according to availability. We will contact you if any adjustment needs to be validated.',
        documentacaoObrigatoria: 'Mandatory documentation for this trip:',
        documentoNacional: 'ID with issuance less than 10 years or valid driver\'s license',
        documentoInternacional: 'Passport with minimum validity of 6 months. Consular visas within validity when necessary',
        enviarCopiaDocumento: 'Please send a copy of passport/ID and visa (if necessary) to email:',
        responsabilidadePatrocinio: 'is exclusively responsible for sponsoring the air tickets necessary for your attendance at the event and period described in the invitation.',
        alteracoesResponsabilidade: 'Changes will be the responsibility of the guest.',
        confirmarNomeDocumento: 'Please confirm if your name is described in the same way as in your original document presented for boarding.',
        informacaoImportante: 'This information is very important to avoid inconvenience at the time of boarding.',
        observacoesImportantes: 'Important Notes:',
        alteracaoAposEmissao: '- We inform that any type of change after ticket issuance will be the full responsibility of the participant.',
        despesasAcompanhanteResponsabilidade: '- Since the event is sponsored by Sanofi and has an educational/scientific nature, any expenses incurred by accompanying guests will be your responsibility.',
        assinaturaSanofi: 'Sanofi',
        opcaoVooNaoAtende: 'The flight options presented do not meet my needs, I need contact for the following reason:',
        motivo: 'Reason...',
        atencao: 'Attention',
        analisarSolicitacao: 'We will analyze your request and contact you shortly.',
        confirmarAeroporto: 'Do you confirm the departure airport:',
        opcaoVooEscolhida: 'and the chosen flight option?',
        confirmar: 'Confirm',
        cancelar: 'Cancel',
        escolherOpcaoIda: 'It is necessary to choose a DEPARTURE option or inform that the air travel does not serve',
        escolherOpcaoVolta: 'It is necessary to choose a RETURN option or inform that the air travel does not serve',
        informarMotivoIda: 'It is necessary to inform the reason why the DEPARTURE air travel does not meet your needs',
        informarMotivoVolta: 'It is necessary to inform the reason why the RETURN air travel does not meet your needs',
        preencherBagagem: 'It is necessary to fill in if you need checked baggage',
        salvar: 'Save',

        // Transfer messages
        noTransferOptions: 'No transfer options available.',
        transferOptions: 'Transfer Options',
        selectTransfer: 'Select a transfer option',
        transfer: 'Transfer',
        transferExtra: 'Extra transfer:',
        transferExtraDescricao: 'Transfer residence x airport and/or event x residence',
        dataHorarioTransfer: 'Transfer date and time will be scheduled according to the event agenda and informed in the informative letter.',
        informarEndereco: 'Please inform your address:',
        enderecoPlaceholder: 'Address...',
        transferDescricao: 'Transfer:',
        transferDescricaoCompleta: 'Airport x Hotel x Airport',
        naoUtilizarTransfer: 'If you will not use it, or have any questions about the transfer service, please let us know in the field below:',
        observacaoPlaceholder: '...',
        informacoesImportantesTransfer: 'Important Transfer Information',
        servicoExclusivo: 'We emphasize that this service is exclusive to the',
        medico: 'physician',
        convidado: 'guest',
        patrocinado: 'sponsored, not extended to the companion. This service will be offered at times corresponding to your air reservation, provided it corresponds to the event period we have related in our database.',
        alterarVoo: 'If you decide to change your flight, the transfer will be cancelled and the displacement will be the responsibility of the',
        alteracoesAtrasos: 'In case of changes, delays and/or flight cancellations by the airline, we kindly ask you to contact us at (11)3777-8414, so we can arrange adjustments to the scheduled transfer.',

        // Hotel messages
        noHotelOptions: 'No hotel options available.',
        hotelOptions: 'Hotel Options',
        selectHotel: 'Select a hotel option',
        hospedagem: 'Accommodation',
        endereco: 'Address:',
        checkin: 'Check-in:',
        checkout: 'Check-out:',
        tipoApartamento: 'Apartment type:',
        emBreveMaisInformacoes: 'We will send more information soon',
        patrocinioDisponivel: 'Sponsorship available during the event period.',
        naoUtilizarHospedagem: 'If you will not use it, or have any questions about the accommodation service, please let us know in the field below:',

        // Contract messages
        contractSent: 'Contract sent successfully!',

        // Form fields
        nome_completo_documento: 'Full Name (as per your document)',
        nome_completo_documento_label: 'Full Name (as per your document)',
        nome_atencao_aereo: '* if you have air travel, please note that the name must be the same as the boarding document',
        nome_cracha: 'Name for Badge',
        nome_cracha_label: 'Name for Badge',
        celular: 'Mobile',
        celular_label: 'Mobile',
        telefone: 'Phone',
        telefone_label: 'Phone',
        email: 'E-mail',
        email_label: 'E-mail',
        rg: 'ID',
        rg_label: 'ID',
        cpf: 'CPF',
        cpf_label: 'CPF',
        crm: 'CRM',
        crm_label: 'CRM',
        estado_crm_label: 'CRM State',
        data_nascimento_label: 'Date of Birth',
        especialidade: 'Specialty',
        especialidade_label: 'Specialty',
        instituicao: 'Institution',
        instituicao_label: 'Institution',
        cep: 'ZIP Code',
        cep_label: 'ZIP Code',
        rua_logradouro: 'Street / Address',
        rua_logradouro_label: 'Street / Address',
        numero: 'Number',
        numero_label: 'Number',
        complemento: 'Complement',
        complemento_label: 'Complement',
        bairro: 'Neighborhood',
        bairro_label: 'Neighborhood',
        cidade_label: 'City',
        estado_label: 'State',
        cidade_embarque_label: 'Departure City',
        necessidade_especial_descricao: 'If you have any special needs, please indicate below:',
        restricao_alimentar_label: 'Dietary Restriction',
        especifique_restricao_alimentar: 'Specify the dietary restriction',
        pcd_label: 'PWD',
        especifique_necessidade_especial: 'Specify the special need',
        confirmar_dados_botao: 'Confirm data',

        // Public agency connection
        noVinculoOrgaoPublico: 'Does not have any kind of connection with Public Agency',
        vinculoOrgaoPublico: 'Has a connection with a Public Agency, even if indirect. (Specify the connection)',
        otherVinculoOrgaoPublico: 'Others. Specify:',
        specifyVinculoOrgaoPublico: 'Please specify the connection with the public agency...',
        enterCpf: 'Enter your CPF'
    }
};

// Função para obter o texto traduzido
export const getText = (key, idioma = 'portugues') => {
    const lang = translations[idioma] || translations.portugues;
    return lang[key] || key;
};

// Função para obter o idioma do participante
export const getParticipantLanguage = (participant) => {
    return participant?.idioma || 'portugues';
};

// Função para obter o idioma do evento
export const getEventLanguage = (event) => {
    return event?.idioma || 'portugues';
}; 